function BlueServiceTicketButton({ clicked }) {
  return (
    <div
      onClick={clicked}
      className="px-[12px] h-[32px] rounded-[6px] border-solid border-[1px] bg-blueColor flex items-center justify-center cursor-pointer"
    >
      <div className="flex gap-1">
        <p className="font-OpenSansSemiBoldtext-[14px] leading-[20px] tracking-[0.14px] capitalize text-white">
          SERVICE TICKET
        </p>
      </div>
    </div>
  );
}

export default BlueServiceTicketButton;
